import { render, staticRenderFns } from "./pageViews.vue?vue&type=template&id=93774a84"
import script from "./pageViews.vue?vue&type=script&lang=js"
export * from "./pageViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports